import { graphql } from 'react-relay';

import { commit } from '../../mutations/commit';

const mutation = graphql`
  mutation fetchPlaidTransactionsMutation($input: FetchTransactionsInput!) {
    fetchPlaidTransactions(input: $input) {
      errorMessage
      successMessage
    }
  }
`;

const fetchPlaidTransactions = (environment, params, args = {}) => {
  const { integrationItemId, startDate, endDate } = params;
  return commit(environment, {
    mutation,
    variables: {
      input: {
        integrationItemId,
        startDate: startDate,
        endDate: endDate,
      },
    },
    ...args,
  });
};

export default fetchPlaidTransactions;
